{
  "name": "poker-power",
  "version": "0.11.3",
  "private": true,
  "main": "index.js",
  "scripts": {
    "lint": "biome check src",
    "serve": "expo start -c --dev-client",
    "start": "expo start -c --dev-client",
    "android": "expo run:android",
    "android:assemble:debug": "cd android && NODE_ENV=development ./gradlew :app:assembleDebug",
    "android:devices": "adb devices -l",
    "android:logcat:native": "adb logcat \"*:E\"",
    "android:logcat:js": "adb logcat \"*:S\" ReactNative:V ReactNativeJS:V",
    "pod:install": "cd ios; bundle exec pod install",
    "pod:update": "cd ios; bundle exec pod install --repo-update",
    "bundle-install": "bundle install",
    "fastlane-ios-certs": "MATCH_PASSWORD=free bundle exec fastlane ios certs",
    "ios": "yarn pod:install && expo run:ios --no-install",
    "web": "expo start --web --dev-client",
    "build:web": "expo export -c -s --platform web --output-dir web-build",
    "build:thirdPartyUtilities": "yarn esbuild ./src/app/utils/thirdPartyUtils --bundle --platform=browser --format=iife --global-name=ppApi --outfile=./web-build/thirdPartyUtils.js --minify",
    "generate:models:dev": "NODE_TLS_REJECT_UNAUTHORIZED=0 yarn mst-gql --format ts --outDir ./src/app/models/api-store https://api.dev.ppwr.io/graphql && yarn format",
    "generate:models:local": "NODE_TLS_REJECT_UNAUTHORIZED=0 yarn mst-gql --format ts --outDir ./src/app/models/api-store http://127.0.0.1:3011/graphql && yarn format",
    "generate:models:test": "NODE_TLS_REJECT_UNAUTHORIZED=0 yarn mst-gql --format ts --outDir ./src/app/models/api-store https://5bjatv9fw4.execute-api.us-east-1.amazonaws.com/test/graphql && yarn format",
    "format": "cd ../../ && pwd && yarn biome:lint && yarn biome:format",
    "biome:lint": "biome check --fix --unsafe",
    "biome:format": "biome format --write",
    "typecheck": "yarn tsc -p tsconfig.app.json",
    "build:ios:production": "bundle exec fastlane ios production",
    "build:ios:beta": "bundle exec fastlane ios beta",
    "build:ios:beta:testflight": "bundle exec fastlane ios testflight_beta",
    "build:android:production": "bundle exec fastlane android production",
    "build:android:beta": "bundle exec fastlane android beta",
    "test": "jest --passWithNoTests",
    "test:watch": "jest --watch",
    "test:cov": "jest --bail --coverage",
    "postinstall": "node scripts/ensure-yarn.js && patch-package",
    "prebuild": "expo prebuild",
    "clean:native": "rm -rf android ios"
  },
  "dependencies": {
    "@2toad/profanity": "2.2.0",
    "@auth0/auth0-spa-js": "2.2.0",
    "@babel/plugin-proposal-decorators": "7.25.9",
    "@babel/plugin-proposal-export-namespace-from": "7.18.9",
    "@datadog/browser-logs": "6.6.3",
    "@datadog/browser-rum": "6.5.1",
    "@datadog/mobile-react-native": "2.12.0",
    "@datadog/mobile-react-native-session-replay": "2.12.0",
    "@datadog/mobile-react-navigation": "2.12.0",
    "@dicebear/core": "^9.4.0",
    "@dicebear/fun-emoji": "^9.4.0",
    "@dicebear/rings": "^9.4.0",
    "@dicebear/shapes": "^9.4.0",
    "@dicebear/thumbs": "^9.4.0",
    "@expo/config": "12.0.7",
    "@expo/metro-runtime": "6.1.2",
    "@expo/vector-icons": "15.0.3",
    "@gorhom/bottom-sheet": "5.2.6",
    "@gorhom/portal": "1.0.14",
    "@invertase/react-native-apple-authentication": "2.2.2",
    "@nestjs/graphql": "13.0.2",
    "@ppwr/game-manager": "*",
    "@ppwr/poker": "*",
    "@ppwr/sdk": "*",
    "@react-native-async-storage/async-storage": "2.2.0",
    "@react-native-clipboard/clipboard": "1.11.1",
    "@react-native-community/netinfo": "11.4.1",
    "@react-native-firebase/analytics": "23.3.1",
    "@react-native-firebase/app": "23.3.1",
    "@react-native-firebase/remote-config": "23.3.1",
    "@react-native-google-signin/google-signin": "13.2.0",
    "@react-native-picker/picker": "2.11.1",
    "@react-native/assets-registry": "0.76.1",
    "@react-navigation/bottom-tabs": "^7.4.0",
    "@react-navigation/drawer": "^7.5.0",
    "@react-navigation/native": "^7.1.8",
    "@react-navigation/native-stack": "^7.3.16",
    "@react-navigation/stack": "6.3.1",
    "@react-oauth/google": "0.12.1",
    "@segment/analytics-next": "1.81.1",
    "@segment/analytics-react-native": "2.21.3",
    "@segment/analytics-react-native-plugin-amplitude-session": "0.4.1",
    "@segment/analytics-react-native-plugin-firebase": "0.4.3",
    "@segment/sovran-react-native": "1.1.3",
    "@svgr/webpack": "6.5.1",
    "@tamagui/react-native-svg": "1.14.4",
    "@tanstack/react-query": "5.67.1",
    "@tanstack/react-table": "8.21.3",
    "@testing-library/jest-native": "5.3.0",
    "agora-rtc-react": "2.4.0",
    "babel-preset-expo": "54.0.0",
    "branch-sdk": "2.86.3",
    "buffer": "*",
    "chalk": "*",
    "class-transformer": "0.5.1",
    "compare-versions": "5.0.3",
    "convex": "^1.28.0",
    "customerio-expo-plugin": "^3.6.2",
    "customerio-reactnative": "^6.5.2",
    "d3-array": "^3.2.4",
    "d3-scale": "^4.0.2",
    "d3-shape": "^3.2.0",
    "date-fns": "4.1.0",
    "dotenv": "16.0.1",
    "enhanced-resolve": "*",
    "eventemitter3": "*",
    "expo": "~54.0.33",
    "expo-apple-authentication": "^55.0.8",
    "expo-application": "~7.0.8",
    "expo-auth-session": "7.0.8",
    "expo-av": "16.0.7",
    "expo-background-task": "1.0.8",
    "expo-blur": "15.0.7",
    "expo-camera": "17.0.8",
    "expo-clipboard": "8.0.7",
    "expo-constants": "~18.0.10",
    "expo-crypto": "15.0.7",
    "expo-datadog": "53.1.0",
    "expo-dev-client": "~6.0.20",
    "expo-device": "~8.0.9",
    "expo-file-system": "19.0.17",
    "expo-font": "14.0.9",
    "expo-image": "3.0.10",
    "expo-keep-awake": "15.0.7",
    "expo-linear-gradient": "15.0.7",
    "expo-linking": "8.0.8",
    "expo-localization": "17.0.7",
    "expo-mail-composer": "15.0.7",
    "expo-print": "15.0.7",
    "expo-router": "6.0.14",
    "expo-screen-orientation": "9.0.7",
    "expo-splash-screen": "55.0.10",
    "expo-status-bar": "3.0.8",
    "expo-task-manager": "14.0.8",
    "expo-updates": "29.0.12",
    "expo-video": "3.0.12",
    "expo-web-browser": "15.0.8",
    "fast-safe-stringify": "2.1.1",
    "firebase": "11.6.0",
    "graphql": "16.10.0",
    "graphql-request": "4.3.0",
    "graphql-type-json": "0.3.2",
    "graphql-ws": "5.16.0",
    "i18n-js": "3.0.11",
    "jwt-decode": "3.1.2",
    "lodash": "4.17.21",
    "lottie-react-native": "7.3.1",
    "metro-resolver": "0.80.12",
    "mobx": "6.10.2",
    "mobx-react-lite": "3.4.0",
    "mobx-state-tree": "5.1.8",
    "mst-gql": "0.17.3",
    "node-fetch": "*",
    "onesignal-expo-plugin": "2.0.1",
    "pino": "8.6.1",
    "pokersolver": "2.1.4",
    "ramda": "0.28.0",
    "react": "19.1.0",
    "react-datepicker": "8.3.0",
    "react-dom": "19.1.0",
    "react-native": "0.81.5",
    "react-native-agora": "4.5.3",
    "react-native-branch": "6.8.0",
    "react-native-check-version": "1.0.20",
    "react-native-circular-progress": "1.4.1",
    "react-native-circular-progress-indicator": "4.4.2",
    "react-native-confirmation-code-field": "7.4.0",
    "react-native-date-picker": "5.0.4",
    "react-native-device-info": "^15.0.2",
    "react-native-drawer-layout": "4.1.8",
    "react-native-element-dropdown": "2.12.4",
    "react-native-gesture-handler": "2.28.0",
    "react-native-get-random-values": "1.11.0",
    "react-native-haptic-feedback": "2.3.3",
    "react-native-json-tree": "1.5.0",
    "react-native-keyboard-spacer": "0.4.1",
    "react-native-localize": "3.4.1",
    "react-native-logs": "5.0.1",
    "react-native-mask-input": "1.2.3",
    "react-native-masked-text": "1.13.0",
    "react-native-modal": "14.0.0-rc.1",
    "react-native-onesignal": "5.1.3",
    "react-native-paper": "5.13.1",
    "react-native-performance-limiter": "0.3.0",
    "react-native-progress": "5.0.0",
    "react-native-qrcode-svg": "6.3.2",
    "react-native-reanimated": "4.1.2",
    "react-native-reanimated-skeleton": "1.5.1",
    "react-native-redash": "18.1.3",
    "react-native-restart": "0.1.0",
    "react-native-safe-area-context": "5.6.1",
    "react-native-screens": "4.16.0",
    "react-native-select-dropdown": "2.0.4",
    "react-native-share": "12.2.0",
    "react-native-small-ui": "^0.3.7",
    "react-native-svg": "15.12.1",
    "react-native-svg-charts": "5.4.0",
    "react-native-svg-transformer": "1.0.0",
    "react-native-svg-web": "1.0.9",
    "react-native-swipe-list-view": "3.2.9",
    "react-native-swiper": "1.6.0",
    "react-native-toast-message": "2.3.3",
    "react-native-url-polyfill": "1.3.0",
    "react-native-video": "6.16.1",
    "react-native-view-shot": "4.0.3",
    "react-native-web": "0.21.0",
    "react-native-web-swiper": "2.2.4",
    "react-native-web-webview": "1.0.2",
    "react-native-webview": "13.15.0",
    "react-native-worklets": "0.5.1",
    "react-onesignal": "3.2.2",
    "react-share": "5.1.0",
    "reflect-metadata": "0.2.2",
    "rxjs": "7.8.1",
    "subscriptions-transport-ws": "*",
    "use-debounce": "9.0.4",
    "uuid": "*",
    "vaul": "0.9.0",
    "zustand": "5.0.3"
  },
  "devDependencies": {
    "@babel/core": "7.26.0",
    "@babel/plugin-proposal-class-properties": "7.18.6",
    "@babel/plugin-proposal-nullish-coalescing-operator": "7.18.6",
    "@babel/plugin-proposal-optional-chaining": "7.21.0",
    "@babel/preset-env": "7.25.3",
    "@babel/runtime": "7.25.0",
    "@biomejs/biome": "1.9.4",
    "@config-plugins/react-native-branch": "^8.0.0",
    "@datadog/datadog-ci": "4.1.3",
    "@expo/cli": "54.0.6",
    "@expo/config-plugins": "54.0.1",
    "@expo/prebuild-config": "54.0.0",
    "@expo/webpack-config": "19.0.1",
    "@pmmmwh/react-refresh-webpack-plugin": "0.6.0",
    "@react-native-community/cli": "15.1.3",
    "@react-native/babel-preset": "0.76.7",
    "@react-native/metro-babel-transformer": "0.78.0",
    "@react-native/metro-config": "0.76.7",
    "@testing-library/jest-native": "5.3.0",
    "@types/branch-sdk": "2",
    "@types/d3-array": "^3.2.2",
    "@types/d3-scale": "^4.0.9",
    "@types/d3-shape": "^3.1.8",
    "@types/identity-obj-proxy": "3.0.2",
    "@types/jest": "29.5.14",
    "@types/ramda": "0.30.2",
    "@types/react": "19.1.10",
    "@types/react-dom": "19.1.7",
    "@types/react-native-svg-charts": "5.0.16",
    "@types/react-refresh": "0.14.6",
    "@types/react-test-renderer": "18.3.1",
    "babel-plugin-module-resolver": "5.0.2",
    "babel-plugin-transform-inline-environment-variables": "^0.4.4",
    "babel-plugin-transform-remove-console": "6.9.4",
    "babel-plugin-tsconfig-paths-module-resolver": "1.0.4",
    "eas-cli": "18.8.0",
    "esbuild": "0.21.5",
    "esbuild-loader": "4.2.0",
    "expo-build-properties": "~0.13.2",
    "firebase-tools": "11.8.0",
    "gradle-to-js": "2.0.1",
    "identity-obj-proxy": "3.0.0",
    "jest": "29.7.0",
    "jest-cucumber": "*",
    "jest-each": "*",
    "jest-expo": "54.0.13",
    "metro": "0.83.1",
    "metro-babel-register": "0.81.0",
    "metro-react-native-babel-transformer": "0.77.0",
    "metro-resolver": "0.81.0",
    "node-libs-browser": "2.2.1",
    "patch-package": "8.0.0",
    "pod-install": "0.3.4",
    "react-refresh": "0.17.0",
    "react-test-renderer": "18.3.1",
    "sharp-cli": "2.1.0",
    "simple-plist": "1.3.1",
    "tsconfig-paths": "4.2.0",
    "tsconfig-paths-webpack-plugin": "4.2.0",
    "tslib": "2.8.1",
    "typescript": "5.9.3",
    "yargs": "15.4.0"
  },
  "expo": {
    "install": {
      "exclude": [
        "react-native-reanimated@3.16.1",
        "react-native-safe-area-context@4.12.0",
        "react-native-webview@13.12.5"
      ]
    },
    "doctor": {
      "skipDependencyValidation": true,
      "skipNativeProjectCheck": true,
      "skipSDKVersionRequirement": true,
      "skipMetroConfigCheck": true,
      "skipLegacyGlobalCliCheck": true,
      "skipDirectDependencyCheck": true,
      "skipDuplicateDependencyCheck": true,
      "reactNativeDirectoryCheck": {
        "exclude": [
          "react-native-branch",
          "react-native-restart",
          "@datadog/mobile-react-native-session-replay",
          "@config-plugins/react-native-branch"
        ],
        "listUnknownPackages": false
      }
    }
  }
}
